module.exports = __webpack_public_path__ + "static/media/service-03.e5157240.png";